import { useMutation } from 'react-query'

import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'

export const useMutateDeleteExpenseReport = () => {
  const mutation = useMutation<void, Error, number>({
    mutationFn: (expenseId) => expenseRepository.deleteReport(expenseId),
  })

  return {
    mutate: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
